<template>
  <b-sidebar
    shadow
    visible
    backdrop
    no-header
    class="show"
    body-class="cp-sidebar__body"
    sidebar-class="cp-sidebar full-height item-tracking"
    @change="toggleScrollbar()"
  >
    <OrderTracking :item="item" :session="session" @clear="toggleScrollbar" />
  </b-sidebar>
</template>

<script>
import {toggleBodyScrollbar} from '@/utils'
import {mapState} from 'vuex'

const OrderTracking = () => import('@/components/Order/OrderTracking')

export default {
  name: 'TrackingSidebar',
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  components: {OrderTracking},
  computed: {
    ...mapState(['session'])
  },
  methods: {
    toggleScrollbar: function() {
      toggleBodyScrollbar()
      this.$emit('clear')
    }
  },
  created() {
    toggleBodyScrollbar(true)
  }
}
</script>

<style scoped>

</style>
